jQuery(document).ready(function () {
    jQuery('#hero-cta-id').on('click', function (e) {
        e.preventDefault();

        lenis.scrollTo('#why-us-section-id', {
            duration: 1.2,
            easing: (t) => 1 - Math.pow(1 - t, 4)
        });
    });
});